import api from "./api";

export const referralService = {
  getDashboard: () => api.get('/admin/referral/dashboard'),
  getRelationships: (params) => api.get('/admin/referral/relationships', { params }),
  getRelationshipDetail: (id) => api.get(`/admin/referral/relationships/${id}`),
  getProgram: () => api.get('/admin/referral/program'),
  getAllSchemes: () => api.get('/admin/referral/schemes'),
  createScheme: (data) => api.post('/admin/referral/schemes', data),
  updateScheme: (id, data) => api.put(`/admin/referral/schemes/${id}`, data),
  deleteScheme: (id) => api.delete(`/admin/referral/schemes/${id}`),
};
